import { useAdminStore } from '@/store/admin';
import jwt_decode from 'jwt-decode';

/**
 * @description Check to see if current admin exist, if so, re-populate
 */
const adminAuth = () => {
  const adminStore = useAdminStore();

  if (localStorage?.google_auth_token) {
    const decoded = jwt_decode(localStorage?.google_auth_token);
    if (decoded && decoded.exp * 1000 > new Date().getTime()) {
      adminStore.isAuthenticated = true;
      adminStore.adminProfile = decoded;
    } else {
      adminStore.isAuthenticated = false;
      adminStore.adminProfile = {};
    }
  }
};

export default adminAuth;
